/*
 * CALENDAR DAYS AND CLOCK TIMES, with no time zone in them.
 *
 * Program items, signage slides and EPG ranges use days on the tenant's calendar ("YYYY-MM-DD")
 * and clock times ("HH:MM") — never instants (docs/API.md → Common). They are compared as the
 * strings they are.
 */

const DAY_PATTERN  = /^\d{4}-\d{2}-\d{2}$/
const TIME_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/

/** Whether a value is a "YYYY-MM-DD" day the API would accept. */
export const isDay = (value: unknown): value is string => typeof value === 'string' && DAY_PATTERN.test(value)

/** Whether a value is an "HH:MM" clock time the API would accept. */
export const isClockTime = (value: unknown): value is string => typeof value === 'string' && TIME_PATTERN.test(value)

/** A window whose end is not after its start runs past midnight into the next day. */
export const crossesMidnight = (from: string, to: string): boolean => isClockTime(from) && isClockTime(to) && to <= from
